// @flow
import AssignedList from './AssignedList';

export default AssignedList;
